import { render, staticRenderFns } from "./ECommerce.vue?vue&type=template&id=14213ca0&"
import script from "./ECommerce.vue?vue&type=script&lang=js&"
export * from "./ECommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports